import React, { useState, useEffect } from 'react'
import axios from 'axios'

import './RelatorRevisorView.css'
import brasao from '../../assets/brasilNav.png'
import assinatura from '../../assets/assPresidente.png'

const RelatorRevisorView = (props) => {
    const [processo, setProcesso] = useState({ dataCriacao: '' })
    const id = props.id || window.location.pathname.slice(26)

    useEffect(() => {
        const url = `/api/ped/getPed/${id}`
        axios(url)
            .then(res => {
                setProcesso(res.data)
            })
            .then()
            .catch(error => {
                alert(error.response.data)
            })
    }, [])

    const voltar = () => {
        window.location = `/etica/documentosPed/${processo._id}`
    }

    const imprimir = (e) => {
        window.print()
    }

    if (processo && processo.membros) {
        return (
            <React.Fragment>
                <div className="container RrBranco">
                    <img src={brasao} alt="Brasil" className='brasaoPed' />
                    <div className='conselho'>CONSELHO REGIONAL DE FISIOTERAPIA E TERAPIA OCUPACIONAL DA 1ª REGIÃO</div>
                    <div className="rRdivLabels">
                        <div className="rRlabels">PROCESSO ÉTICO DISCIPLINAR</div>
                        <div className="rRlabels">PED Nº {processo.numeroPed}</div>
                    </div>
                    <div className="rRdiv">
                        <div className="rRdiv1">
                            <span className="rRrepresentante">Representante: </span>
                            <div className="rRrepresentante">{processo.representante}</div>
                        </div>
                        <div className="rRdiv1">
                            <span className="rRrepresentante">Representado: </span>
                            <div className="rRrepresentante">Dr(a). {processo.representado} </div>
                            <div className="rRrepresentante">- CREFITO {processo.numeroCrefito}</div>
                        </div>
                    </div>
                    <div className="rRdespachoPresidencia">DESPACHO DA PRESIDÊNCIA</div>
                    <div className="rRdespachoTexto">
                        <p>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            Cumprindo o preconizado na Resolução COFFITO nº 423/2013, designo o(a) &nbsp;
                            {processo.membros.relatorPronome} {processo.membros.relator}, CREFITO &nbsp;
                            {processo.membros.relatorCrefito}, como Relator(a), e o(a) {processo.membros.revisorPronome}
                            &nbsp; {processo.membros.revisor}, CREFITO {processo.membros.revisorCrefito}, como
                            &nbsp;Revisor(a), do processo em tela.
                            <br />
                            <br />
                            <br />
                            <br />
                            Recife, {processo.membros.dateRr.slice(0, 10)}.
                        </p>
                    </div>
                    <img src={assinatura} alt="Presidente" className='assPresidente' />
                    <div className="identPresidente">Dr. SILANO SOUTO MENDES BARROS <br /> Presidente</div>
                </div>
                <button className="botaoNPed" onClick={e => voltar(e)}>VOLTAR</button>
                <button className="botaoNPed"
                    style={{ display: 'block', margin: 'auto', marginTop: '1vh' }}
                    onClick={e => imprimir(e)}>IMPRIMIR</button>
            </React.Fragment>
        )
    } else {
        return <div></div>
    }
}

export default RelatorRevisorView